unit View.Cfop_Configuracoes.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewCfop_ConfiguracoesEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbcfop: TLabel;
    edcfop: TDBEdit;
    lbcfop_movimenta_estoque: TLabel;
    edcfop_movimenta_estoque: TDBEdit;
    lbcfop_gera_financeiro: TLabel;
    edcfop_gera_financeiro: TDBEdit;
    lbcfop_substituicao: TLabel;
    edcfop_substituicao: TDBEdit;
    lbcfop_simples_faturamento: TLabel;
    edcfop_simples_faturamento: TDBEdit;
    lbcfop_servico: TLabel;
    edcfop_servico: TDBEdit;
    lbcfop_participa_dre: TLabel;
    edcfop_participa_dre: TDBEdit;
    lbcfop_devolucao: TLabel;
    edcfop_devolucao: TDBEdit;
    lbcfop_transporte: TLabel;
    edcfop_transporte: TDBEdit;
    lbcfop_combustivel: TLabel;
    edcfop_combustivel: TDBEdit;
    lbcfop_transferencia: TLabel;
    edcfop_transferencia: TDBEdit;
    lbcfop_preco_custo: TLabel;
    edcfop_preco_custo: TDBEdit;
    lbcfop_perda: TLabel;
    edcfop_perda: TDBEdit;
    lbcfop_conciliacao_cupons: TLabel;
    edcfop_conciliacao_cupons: TDBEdit;
    lbcfop_tributa_pis_cofins: TLabel;
    edcfop_tributa_pis_cofins: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientCfop_ConfiguracoesGet: TXDataWebClient;
    XDataClientCfop_ConfiguracoesDelete: TXDataWebClient;
    Cfop_ConfiguracoesDataset: TXDataWebDataSet;
    Cfop_ConfiguracoesDatasetid: TIntegerField;
    Cfop_ConfiguracoesDatasetaliado_id: TIntegerField;
    Cfop_ConfiguracoesDatasetdata_base_id: TIntegerField;
    Cfop_ConfiguracoesDatasetcfop: TStringField;
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_substituicao: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_servico: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_participa_dre: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_devolucao: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_transporte: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_combustivel: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_transferencia: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_preco_custo: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_perda: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons: TBooleanField;
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins: TBooleanField;
    Cfop_ConfiguracoesDatasetcodigo_interno: TIntegerField;
    Cfop_ConfiguracoesDatasetexcluido: TBooleanField;
    Cfop_ConfiguracoesDatasetinclusao: TDateTimeField;
    Cfop_ConfiguracoesDatasetalteracao: TDateTimeField;
    Cfop_ConfiguracoesDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientCfop_ConfiguracoesGetLoad(Response: TXDataClientResponse);
    procedure XDataClientCfop_ConfiguracoesDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientCfop_ConfiguracoesDeleteError(Error: TXDataClientError);
    procedure Cfop_ConfiguracoesDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewCfop_ConfiguracoesEdit: TFViewCfop_ConfiguracoesEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCfop_ConfiguracoesEdit }

procedure TFViewCfop_ConfiguracoesEdit.btSaveClick(Sender: TObject);
begin
  if Cfop_ConfiguracoesDataset.State in dsEditModes then
  begin
        Cfop_ConfiguracoesDataset.Post;
    Cfop_ConfiguracoesDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewCfop_ConfiguracoesEdit.btDeleteClick(Sender: TObject);
begin
  if Cfop_ConfiguracoesDataset.State in dsEditModes then
    Cfop_ConfiguracoesDataset.Post;
  XDataClientCfop_ConfiguracoesDelete.Delete(Cfop_ConfiguracoesDataset.EntitySetName,
    TJSObject(Cfop_ConfiguracoesDataset.CurrentData));
end;


class function TFViewCfop_ConfiguracoesEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCfop_ConfiguracoesEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewCfop_ConfiguracoesEdit.InsertEntity;
begin
  Cfop_ConfiguracoesDataset.Close;
  Cfop_ConfiguracoesDataset.SetJsonData('{}');
  Cfop_ConfiguracoesDataset.Open;
  Cfop_ConfiguracoesDataset.Insert;
end;

class function TFViewCfop_ConfiguracoesEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCfop_ConfiguracoesEdit(AForm).FInserting := AInserting;
    TFViewCfop_ConfiguracoesEdit(AForm).FId := AId;
    TFViewCfop_ConfiguracoesEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCfop_ConfiguracoesEdit(AForm).InsertEntity
    else
      TFViewCfop_ConfiguracoesEdit(AForm).LoadEntity;
    TFViewCfop_ConfiguracoesEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewCfop_ConfiguracoesEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCfop_ConfiguracoesEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Cfop_ConfiguracoesDataset.Connection.Model.DefaultSchema.FindEntityType(
      Cfop_ConfiguracoesDataset.EntitySetName
    )
  );
  XDataClientCfop_ConfiguracoesGet.Get(Cfop_ConfiguracoesDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCfop_ConfiguracoesEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewCfop_ConfiguracoesEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCfop_ConfiguracoesEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCfop_ConfiguracoesEdit.XDataClientCfop_ConfiguracoesGetLoad(Response: TXDataClientResponse);
begin
  Cfop_ConfiguracoesDataset.Close;
  Cfop_ConfiguracoesDataset.SetJsonData(Response.Result);
  Cfop_ConfiguracoesDataset.Open;
  
  Cfop_ConfiguracoesDataset.Edit;  
end;

procedure TFViewCfop_ConfiguracoesEdit.XDataClientCfop_ConfiguracoesDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewCfop_ConfiguracoesEdit.XDataClientCfop_ConfiguracoesDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewCfop_ConfiguracoesEdit.Cfop_ConfiguracoesDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCfop_ConfiguracoesEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewCfop_ConfiguracoesEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.cfop_configuracoes.form.message');
  lbMessage := TLabel.Create('view.cfop_configuracoes.form.message.label');
  btCloseMessage := TButton.Create('view.cfop_configuracoes.form.message.button');
  btCancel := TButton.Create('view.cfop_configuracoes.form.btBack');
  btSave := TButton.Create('view.cfop_configuracoes.form.btSave');
  btDelete := TButton.Create('view.cfop_configuracoes.form.btDelete');
  lbid := TLabel.Create('view.cfop_configuracoes.form.lbid');
  edid := TDBEdit.Create('view.cfop_configuracoes.form.edid');
  lbaliado_id := TLabel.Create('view.cfop_configuracoes.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.cfop_configuracoes.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.cfop_configuracoes.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.cfop_configuracoes.form.eddata_base_id');
  lbcfop := TLabel.Create('view.cfop_configuracoes.form.lbcfop');
  edcfop := TDBEdit.Create('view.cfop_configuracoes.form.edcfop');
  lbcfop_movimenta_estoque := TLabel.Create('view.cfop_configuracoes.form.lbcfop_movimenta_estoque');
  edcfop_movimenta_estoque := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_movimenta_estoque');
  lbcfop_gera_financeiro := TLabel.Create('view.cfop_configuracoes.form.lbcfop_gera_financeiro');
  edcfop_gera_financeiro := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_gera_financeiro');
  lbcfop_substituicao := TLabel.Create('view.cfop_configuracoes.form.lbcfop_substituicao');
  edcfop_substituicao := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_substituicao');
  lbcfop_simples_faturamento := TLabel.Create('view.cfop_configuracoes.form.lbcfop_simples_faturamento');
  edcfop_simples_faturamento := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_simples_faturamento');
  lbcfop_servico := TLabel.Create('view.cfop_configuracoes.form.lbcfop_servico');
  edcfop_servico := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_servico');
  lbcfop_participa_dre := TLabel.Create('view.cfop_configuracoes.form.lbcfop_participa_dre');
  edcfop_participa_dre := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_participa_dre');
  lbcfop_devolucao := TLabel.Create('view.cfop_configuracoes.form.lbcfop_devolucao');
  edcfop_devolucao := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_devolucao');
  lbcfop_transporte := TLabel.Create('view.cfop_configuracoes.form.lbcfop_transporte');
  edcfop_transporte := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_transporte');
  lbcfop_combustivel := TLabel.Create('view.cfop_configuracoes.form.lbcfop_combustivel');
  edcfop_combustivel := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_combustivel');
  lbcfop_transferencia := TLabel.Create('view.cfop_configuracoes.form.lbcfop_transferencia');
  edcfop_transferencia := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_transferencia');
  lbcfop_preco_custo := TLabel.Create('view.cfop_configuracoes.form.lbcfop_preco_custo');
  edcfop_preco_custo := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_preco_custo');
  lbcfop_perda := TLabel.Create('view.cfop_configuracoes.form.lbcfop_perda');
  edcfop_perda := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_perda');
  lbcfop_conciliacao_cupons := TLabel.Create('view.cfop_configuracoes.form.lbcfop_conciliacao_cupons');
  edcfop_conciliacao_cupons := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_conciliacao_cupons');
  lbcfop_tributa_pis_cofins := TLabel.Create('view.cfop_configuracoes.form.lbcfop_tributa_pis_cofins');
  edcfop_tributa_pis_cofins := TDBEdit.Create('view.cfop_configuracoes.form.edcfop_tributa_pis_cofins');
  lbcodigo_interno := TLabel.Create('view.cfop_configuracoes.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.cfop_configuracoes.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.cfop_configuracoes.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.cfop_configuracoes.form.edexcluido');
  lbinclusao := TLabel.Create('view.cfop_configuracoes.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.cfop_configuracoes.form.edinclusao');
  lbalteracao := TLabel.Create('view.cfop_configuracoes.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.cfop_configuracoes.form.edalteracao');
  lbexclusao := TLabel.Create('view.cfop_configuracoes.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.cfop_configuracoes.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Cfop_ConfiguracoesDataset := TXDataWebDataSet.Create(Self);
  Cfop_ConfiguracoesDatasetid := TIntegerField.Create(Self);
  Cfop_ConfiguracoesDatasetaliado_id := TIntegerField.Create(Self);
  Cfop_ConfiguracoesDatasetdata_base_id := TIntegerField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop := TStringField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_movimenta_estoque := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_gera_financeiro := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_substituicao := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_simples_faturamento := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_servico := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_participa_dre := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_devolucao := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_transporte := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_combustivel := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_transferencia := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_preco_custo := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_perda := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetcodigo_interno := TIntegerField.Create(Self);
  Cfop_ConfiguracoesDatasetexcluido := TBooleanField.Create(Self);
  Cfop_ConfiguracoesDatasetinclusao := TDateTimeField.Create(Self);
  Cfop_ConfiguracoesDatasetalteracao := TDateTimeField.Create(Self);
  Cfop_ConfiguracoesDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientCfop_ConfiguracoesGet := TXDataWebClient.Create(Self);
  XDataClientCfop_ConfiguracoesDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbcfop.BeforeLoadDFMValues;
  edcfop.BeforeLoadDFMValues;
  lbcfop_movimenta_estoque.BeforeLoadDFMValues;
  edcfop_movimenta_estoque.BeforeLoadDFMValues;
  lbcfop_gera_financeiro.BeforeLoadDFMValues;
  edcfop_gera_financeiro.BeforeLoadDFMValues;
  lbcfop_substituicao.BeforeLoadDFMValues;
  edcfop_substituicao.BeforeLoadDFMValues;
  lbcfop_simples_faturamento.BeforeLoadDFMValues;
  edcfop_simples_faturamento.BeforeLoadDFMValues;
  lbcfop_servico.BeforeLoadDFMValues;
  edcfop_servico.BeforeLoadDFMValues;
  lbcfop_participa_dre.BeforeLoadDFMValues;
  edcfop_participa_dre.BeforeLoadDFMValues;
  lbcfop_devolucao.BeforeLoadDFMValues;
  edcfop_devolucao.BeforeLoadDFMValues;
  lbcfop_transporte.BeforeLoadDFMValues;
  edcfop_transporte.BeforeLoadDFMValues;
  lbcfop_combustivel.BeforeLoadDFMValues;
  edcfop_combustivel.BeforeLoadDFMValues;
  lbcfop_transferencia.BeforeLoadDFMValues;
  edcfop_transferencia.BeforeLoadDFMValues;
  lbcfop_preco_custo.BeforeLoadDFMValues;
  edcfop_preco_custo.BeforeLoadDFMValues;
  lbcfop_perda.BeforeLoadDFMValues;
  edcfop_perda.BeforeLoadDFMValues;
  lbcfop_conciliacao_cupons.BeforeLoadDFMValues;
  edcfop_conciliacao_cupons.BeforeLoadDFMValues;
  lbcfop_tributa_pis_cofins.BeforeLoadDFMValues;
  edcfop_tributa_pis_cofins.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDataset.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetid.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetaliado_id.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetdata_base_id.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_gera_financeiro.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_substituicao.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_simples_faturamento.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_servico.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_participa_dre.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_devolucao.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_transporte.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_combustivel.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_transferencia.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_preco_custo.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_perda.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetcodigo_interno.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetexcluido.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetinclusao.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetalteracao.BeforeLoadDFMValues;
  Cfop_ConfiguracoesDatasetexclusao.BeforeLoadDFMValues;
  XDataClientCfop_ConfiguracoesGet.BeforeLoadDFMValues;
  XDataClientCfop_ConfiguracoesDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewCfop_ConfiguracoesEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 886;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 826;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 826;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 826;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbcfop.SetParentComponent(Self);
    lbcfop.Name := 'lbcfop';
    lbcfop.Left := 24;
    lbcfop.Top := 273;
    lbcfop.Width := 14;
    lbcfop.Height := 13;
    lbcfop.Caption := 'cfop:';
    lbcfop.Transparent := True;
    edcfop.SetParentComponent(Self);
    edcfop.Name := 'edcfop';
    edcfop.Left := 221;
    edcfop.Top := 270;
    edcfop.Width := 200;
    edcfop.Height := 21;
    edcfop.Enabled := True;
    edcfop.TabOrder := 9;
    edcfop.Text := 'edcfop';
    edcfop.DataField := 'cfop';
    edcfop.DataSource := DataSource;
    lbcfop_movimenta_estoque.SetParentComponent(Self);
    lbcfop_movimenta_estoque.Name := 'lbcfop_movimenta_estoque';
    lbcfop_movimenta_estoque.Left := 24;
    lbcfop_movimenta_estoque.Top := 300;
    lbcfop_movimenta_estoque.Width := 14;
    lbcfop_movimenta_estoque.Height := 13;
    lbcfop_movimenta_estoque.Caption := 'cfop_movimenta_estoque:';
    lbcfop_movimenta_estoque.Transparent := True;
    edcfop_movimenta_estoque.SetParentComponent(Self);
    edcfop_movimenta_estoque.Name := 'edcfop_movimenta_estoque';
    edcfop_movimenta_estoque.Left := 221;
    edcfop_movimenta_estoque.Top := 297;
    edcfop_movimenta_estoque.Width := 200;
    edcfop_movimenta_estoque.Height := 21;
    edcfop_movimenta_estoque.Enabled := True;
    edcfop_movimenta_estoque.TabOrder := 10;
    edcfop_movimenta_estoque.Text := 'edcfop_movimenta_estoque';
    edcfop_movimenta_estoque.DataField := 'cfop_movimenta_estoque';
    edcfop_movimenta_estoque.DataSource := DataSource;
    lbcfop_gera_financeiro.SetParentComponent(Self);
    lbcfop_gera_financeiro.Name := 'lbcfop_gera_financeiro';
    lbcfop_gera_financeiro.Left := 24;
    lbcfop_gera_financeiro.Top := 327;
    lbcfop_gera_financeiro.Width := 14;
    lbcfop_gera_financeiro.Height := 13;
    lbcfop_gera_financeiro.Caption := 'cfop_gera_financeiro:';
    lbcfop_gera_financeiro.Transparent := True;
    edcfop_gera_financeiro.SetParentComponent(Self);
    edcfop_gera_financeiro.Name := 'edcfop_gera_financeiro';
    edcfop_gera_financeiro.Left := 221;
    edcfop_gera_financeiro.Top := 324;
    edcfop_gera_financeiro.Width := 200;
    edcfop_gera_financeiro.Height := 21;
    edcfop_gera_financeiro.Enabled := True;
    edcfop_gera_financeiro.TabOrder := 11;
    edcfop_gera_financeiro.Text := 'edcfop_gera_financeiro';
    edcfop_gera_financeiro.DataField := 'cfop_gera_financeiro';
    edcfop_gera_financeiro.DataSource := DataSource;
    lbcfop_substituicao.SetParentComponent(Self);
    lbcfop_substituicao.Name := 'lbcfop_substituicao';
    lbcfop_substituicao.Left := 24;
    lbcfop_substituicao.Top := 354;
    lbcfop_substituicao.Width := 14;
    lbcfop_substituicao.Height := 13;
    lbcfop_substituicao.Caption := 'cfop_substituicao:';
    lbcfop_substituicao.Transparent := True;
    edcfop_substituicao.SetParentComponent(Self);
    edcfop_substituicao.Name := 'edcfop_substituicao';
    edcfop_substituicao.Left := 221;
    edcfop_substituicao.Top := 351;
    edcfop_substituicao.Width := 200;
    edcfop_substituicao.Height := 21;
    edcfop_substituicao.Enabled := True;
    edcfop_substituicao.TabOrder := 12;
    edcfop_substituicao.Text := 'edcfop_substituicao';
    edcfop_substituicao.DataField := 'cfop_substituicao';
    edcfop_substituicao.DataSource := DataSource;
    lbcfop_simples_faturamento.SetParentComponent(Self);
    lbcfop_simples_faturamento.Name := 'lbcfop_simples_faturamento';
    lbcfop_simples_faturamento.Left := 24;
    lbcfop_simples_faturamento.Top := 381;
    lbcfop_simples_faturamento.Width := 14;
    lbcfop_simples_faturamento.Height := 13;
    lbcfop_simples_faturamento.Caption := 'cfop_simples_faturamento:';
    lbcfop_simples_faturamento.Transparent := True;
    edcfop_simples_faturamento.SetParentComponent(Self);
    edcfop_simples_faturamento.Name := 'edcfop_simples_faturamento';
    edcfop_simples_faturamento.Left := 221;
    edcfop_simples_faturamento.Top := 378;
    edcfop_simples_faturamento.Width := 200;
    edcfop_simples_faturamento.Height := 21;
    edcfop_simples_faturamento.Enabled := True;
    edcfop_simples_faturamento.TabOrder := 13;
    edcfop_simples_faturamento.Text := 'edcfop_simples_faturamento';
    edcfop_simples_faturamento.DataField := 'cfop_simples_faturamento';
    edcfop_simples_faturamento.DataSource := DataSource;
    lbcfop_servico.SetParentComponent(Self);
    lbcfop_servico.Name := 'lbcfop_servico';
    lbcfop_servico.Left := 24;
    lbcfop_servico.Top := 408;
    lbcfop_servico.Width := 14;
    lbcfop_servico.Height := 13;
    lbcfop_servico.Caption := 'cfop_servico:';
    lbcfop_servico.Transparent := True;
    edcfop_servico.SetParentComponent(Self);
    edcfop_servico.Name := 'edcfop_servico';
    edcfop_servico.Left := 221;
    edcfop_servico.Top := 405;
    edcfop_servico.Width := 200;
    edcfop_servico.Height := 21;
    edcfop_servico.Enabled := True;
    edcfop_servico.TabOrder := 14;
    edcfop_servico.Text := 'edcfop_servico';
    edcfop_servico.DataField := 'cfop_servico';
    edcfop_servico.DataSource := DataSource;
    lbcfop_participa_dre.SetParentComponent(Self);
    lbcfop_participa_dre.Name := 'lbcfop_participa_dre';
    lbcfop_participa_dre.Left := 24;
    lbcfop_participa_dre.Top := 435;
    lbcfop_participa_dre.Width := 14;
    lbcfop_participa_dre.Height := 13;
    lbcfop_participa_dre.Caption := 'cfop_participa_dre:';
    lbcfop_participa_dre.Transparent := True;
    edcfop_participa_dre.SetParentComponent(Self);
    edcfop_participa_dre.Name := 'edcfop_participa_dre';
    edcfop_participa_dre.Left := 221;
    edcfop_participa_dre.Top := 432;
    edcfop_participa_dre.Width := 200;
    edcfop_participa_dre.Height := 21;
    edcfop_participa_dre.Enabled := True;
    edcfop_participa_dre.TabOrder := 15;
    edcfop_participa_dre.Text := 'edcfop_participa_dre';
    edcfop_participa_dre.DataField := 'cfop_participa_dre';
    edcfop_participa_dre.DataSource := DataSource;
    lbcfop_devolucao.SetParentComponent(Self);
    lbcfop_devolucao.Name := 'lbcfop_devolucao';
    lbcfop_devolucao.Left := 24;
    lbcfop_devolucao.Top := 462;
    lbcfop_devolucao.Width := 14;
    lbcfop_devolucao.Height := 13;
    lbcfop_devolucao.Caption := 'cfop_devolucao:';
    lbcfop_devolucao.Transparent := True;
    edcfop_devolucao.SetParentComponent(Self);
    edcfop_devolucao.Name := 'edcfop_devolucao';
    edcfop_devolucao.Left := 221;
    edcfop_devolucao.Top := 459;
    edcfop_devolucao.Width := 200;
    edcfop_devolucao.Height := 21;
    edcfop_devolucao.Enabled := True;
    edcfop_devolucao.TabOrder := 16;
    edcfop_devolucao.Text := 'edcfop_devolucao';
    edcfop_devolucao.DataField := 'cfop_devolucao';
    edcfop_devolucao.DataSource := DataSource;
    lbcfop_transporte.SetParentComponent(Self);
    lbcfop_transporte.Name := 'lbcfop_transporte';
    lbcfop_transporte.Left := 24;
    lbcfop_transporte.Top := 489;
    lbcfop_transporte.Width := 14;
    lbcfop_transporte.Height := 13;
    lbcfop_transporte.Caption := 'cfop_transporte:';
    lbcfop_transporte.Transparent := True;
    edcfop_transporte.SetParentComponent(Self);
    edcfop_transporte.Name := 'edcfop_transporte';
    edcfop_transporte.Left := 221;
    edcfop_transporte.Top := 486;
    edcfop_transporte.Width := 200;
    edcfop_transporte.Height := 21;
    edcfop_transporte.Enabled := True;
    edcfop_transporte.TabOrder := 17;
    edcfop_transporte.Text := 'edcfop_transporte';
    edcfop_transporte.DataField := 'cfop_transporte';
    edcfop_transporte.DataSource := DataSource;
    lbcfop_combustivel.SetParentComponent(Self);
    lbcfop_combustivel.Name := 'lbcfop_combustivel';
    lbcfop_combustivel.Left := 24;
    lbcfop_combustivel.Top := 516;
    lbcfop_combustivel.Width := 14;
    lbcfop_combustivel.Height := 13;
    lbcfop_combustivel.Caption := 'cfop_combustivel:';
    lbcfop_combustivel.Transparent := True;
    edcfop_combustivel.SetParentComponent(Self);
    edcfop_combustivel.Name := 'edcfop_combustivel';
    edcfop_combustivel.Left := 221;
    edcfop_combustivel.Top := 513;
    edcfop_combustivel.Width := 200;
    edcfop_combustivel.Height := 21;
    edcfop_combustivel.Enabled := True;
    edcfop_combustivel.TabOrder := 18;
    edcfop_combustivel.Text := 'edcfop_combustivel';
    edcfop_combustivel.DataField := 'cfop_combustivel';
    edcfop_combustivel.DataSource := DataSource;
    lbcfop_transferencia.SetParentComponent(Self);
    lbcfop_transferencia.Name := 'lbcfop_transferencia';
    lbcfop_transferencia.Left := 24;
    lbcfop_transferencia.Top := 543;
    lbcfop_transferencia.Width := 14;
    lbcfop_transferencia.Height := 13;
    lbcfop_transferencia.Caption := 'cfop_transferencia:';
    lbcfop_transferencia.Transparent := True;
    edcfop_transferencia.SetParentComponent(Self);
    edcfop_transferencia.Name := 'edcfop_transferencia';
    edcfop_transferencia.Left := 221;
    edcfop_transferencia.Top := 540;
    edcfop_transferencia.Width := 200;
    edcfop_transferencia.Height := 21;
    edcfop_transferencia.Enabled := True;
    edcfop_transferencia.TabOrder := 19;
    edcfop_transferencia.Text := 'edcfop_transferencia';
    edcfop_transferencia.DataField := 'cfop_transferencia';
    edcfop_transferencia.DataSource := DataSource;
    lbcfop_preco_custo.SetParentComponent(Self);
    lbcfop_preco_custo.Name := 'lbcfop_preco_custo';
    lbcfop_preco_custo.Left := 24;
    lbcfop_preco_custo.Top := 570;
    lbcfop_preco_custo.Width := 14;
    lbcfop_preco_custo.Height := 13;
    lbcfop_preco_custo.Caption := 'cfop_preco_custo:';
    lbcfop_preco_custo.Transparent := True;
    edcfop_preco_custo.SetParentComponent(Self);
    edcfop_preco_custo.Name := 'edcfop_preco_custo';
    edcfop_preco_custo.Left := 221;
    edcfop_preco_custo.Top := 567;
    edcfop_preco_custo.Width := 200;
    edcfop_preco_custo.Height := 21;
    edcfop_preco_custo.Enabled := True;
    edcfop_preco_custo.TabOrder := 20;
    edcfop_preco_custo.Text := 'edcfop_preco_custo';
    edcfop_preco_custo.DataField := 'cfop_preco_custo';
    edcfop_preco_custo.DataSource := DataSource;
    lbcfop_perda.SetParentComponent(Self);
    lbcfop_perda.Name := 'lbcfop_perda';
    lbcfop_perda.Left := 24;
    lbcfop_perda.Top := 597;
    lbcfop_perda.Width := 14;
    lbcfop_perda.Height := 13;
    lbcfop_perda.Caption := 'cfop_perda:';
    lbcfop_perda.Transparent := True;
    edcfop_perda.SetParentComponent(Self);
    edcfop_perda.Name := 'edcfop_perda';
    edcfop_perda.Left := 221;
    edcfop_perda.Top := 594;
    edcfop_perda.Width := 200;
    edcfop_perda.Height := 21;
    edcfop_perda.Enabled := True;
    edcfop_perda.TabOrder := 21;
    edcfop_perda.Text := 'edcfop_perda';
    edcfop_perda.DataField := 'cfop_perda';
    edcfop_perda.DataSource := DataSource;
    lbcfop_conciliacao_cupons.SetParentComponent(Self);
    lbcfop_conciliacao_cupons.Name := 'lbcfop_conciliacao_cupons';
    lbcfop_conciliacao_cupons.Left := 24;
    lbcfop_conciliacao_cupons.Top := 624;
    lbcfop_conciliacao_cupons.Width := 14;
    lbcfop_conciliacao_cupons.Height := 13;
    lbcfop_conciliacao_cupons.Caption := 'cfop_conciliacao_cupons:';
    lbcfop_conciliacao_cupons.Transparent := True;
    edcfop_conciliacao_cupons.SetParentComponent(Self);
    edcfop_conciliacao_cupons.Name := 'edcfop_conciliacao_cupons';
    edcfop_conciliacao_cupons.Left := 221;
    edcfop_conciliacao_cupons.Top := 621;
    edcfop_conciliacao_cupons.Width := 200;
    edcfop_conciliacao_cupons.Height := 21;
    edcfop_conciliacao_cupons.Enabled := True;
    edcfop_conciliacao_cupons.TabOrder := 22;
    edcfop_conciliacao_cupons.Text := 'edcfop_conciliacao_cupons';
    edcfop_conciliacao_cupons.DataField := 'cfop_conciliacao_cupons';
    edcfop_conciliacao_cupons.DataSource := DataSource;
    lbcfop_tributa_pis_cofins.SetParentComponent(Self);
    lbcfop_tributa_pis_cofins.Name := 'lbcfop_tributa_pis_cofins';
    lbcfop_tributa_pis_cofins.Left := 24;
    lbcfop_tributa_pis_cofins.Top := 651;
    lbcfop_tributa_pis_cofins.Width := 14;
    lbcfop_tributa_pis_cofins.Height := 13;
    lbcfop_tributa_pis_cofins.Caption := 'cfop_tributa_pis_cofins:';
    lbcfop_tributa_pis_cofins.Transparent := True;
    edcfop_tributa_pis_cofins.SetParentComponent(Self);
    edcfop_tributa_pis_cofins.Name := 'edcfop_tributa_pis_cofins';
    edcfop_tributa_pis_cofins.Left := 221;
    edcfop_tributa_pis_cofins.Top := 648;
    edcfop_tributa_pis_cofins.Width := 200;
    edcfop_tributa_pis_cofins.Height := 21;
    edcfop_tributa_pis_cofins.Enabled := True;
    edcfop_tributa_pis_cofins.TabOrder := 23;
    edcfop_tributa_pis_cofins.Text := 'edcfop_tributa_pis_cofins';
    edcfop_tributa_pis_cofins.DataField := 'cfop_tributa_pis_cofins';
    edcfop_tributa_pis_cofins.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 678;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 675;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 24;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 705;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 702;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 25;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 732;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 729;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 26;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 759;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 756;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 27;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 786;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 783;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 28;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Cfop_ConfiguracoesDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Cfop_ConfiguracoesDataset.SetParentComponent(Self);
    Cfop_ConfiguracoesDataset.Name := 'Cfop_ConfiguracoesDataset';
    Cfop_ConfiguracoesDataset.AfterApplyUpdates := Cfop_ConfiguracoesDatasetAfterApplyUpdates;
    Cfop_ConfiguracoesDataset.EntitySetName := 'Cfop_Configuracoes';
    Cfop_ConfiguracoesDataset.Connection := DMConnection.ApiConnection;
    Cfop_ConfiguracoesDataset.Left := 176;
    Cfop_ConfiguracoesDataset.Top := 8;
    Cfop_ConfiguracoesDatasetid.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetid.Name := 'Cfop_ConfiguracoesDatasetid';
    Cfop_ConfiguracoesDatasetid.FieldName := 'id';
    Cfop_ConfiguracoesDatasetid.Required := True;
    Cfop_ConfiguracoesDatasetaliado_id.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetaliado_id.Name := 'Cfop_ConfiguracoesDatasetaliado_id';
    Cfop_ConfiguracoesDatasetaliado_id.FieldName := 'aliado_id';
    Cfop_ConfiguracoesDatasetaliado_id.Required := True;
    Cfop_ConfiguracoesDatasetdata_base_id.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetdata_base_id.Name := 'Cfop_ConfiguracoesDatasetdata_base_id';
    Cfop_ConfiguracoesDatasetdata_base_id.FieldName := 'data_base_id';
    Cfop_ConfiguracoesDatasetdata_base_id.Required := True;
    Cfop_ConfiguracoesDatasetcfop.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop.Name := 'Cfop_ConfiguracoesDatasetcfop';
    Cfop_ConfiguracoesDatasetcfop.FieldName := 'cfop';
    Cfop_ConfiguracoesDatasetcfop.Required := True;
    Cfop_ConfiguracoesDatasetcfop.Size := 255;
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.Name := 'Cfop_ConfiguracoesDatasetcfop_movimenta_estoque';
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.FieldName := 'cfop_movimenta_estoque';
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.Required := True;
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro.Name := 'Cfop_ConfiguracoesDatasetcfop_gera_financeiro';
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro.FieldName := 'cfop_gera_financeiro';
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro.Required := True;
    Cfop_ConfiguracoesDatasetcfop_substituicao.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_substituicao.Name := 'Cfop_ConfiguracoesDatasetcfop_substituicao';
    Cfop_ConfiguracoesDatasetcfop_substituicao.FieldName := 'cfop_substituicao';
    Cfop_ConfiguracoesDatasetcfop_substituicao.Required := True;
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento.Name := 'Cfop_ConfiguracoesDatasetcfop_simples_faturamento';
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento.FieldName := 'cfop_simples_faturamento';
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento.Required := True;
    Cfop_ConfiguracoesDatasetcfop_servico.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_servico.Name := 'Cfop_ConfiguracoesDatasetcfop_servico';
    Cfop_ConfiguracoesDatasetcfop_servico.FieldName := 'cfop_servico';
    Cfop_ConfiguracoesDatasetcfop_servico.Required := True;
    Cfop_ConfiguracoesDatasetcfop_participa_dre.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_participa_dre.Name := 'Cfop_ConfiguracoesDatasetcfop_participa_dre';
    Cfop_ConfiguracoesDatasetcfop_participa_dre.FieldName := 'cfop_participa_dre';
    Cfop_ConfiguracoesDatasetcfop_participa_dre.Required := True;
    Cfop_ConfiguracoesDatasetcfop_devolucao.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_devolucao.Name := 'Cfop_ConfiguracoesDatasetcfop_devolucao';
    Cfop_ConfiguracoesDatasetcfop_devolucao.FieldName := 'cfop_devolucao';
    Cfop_ConfiguracoesDatasetcfop_devolucao.Required := True;
    Cfop_ConfiguracoesDatasetcfop_transporte.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_transporte.Name := 'Cfop_ConfiguracoesDatasetcfop_transporte';
    Cfop_ConfiguracoesDatasetcfop_transporte.FieldName := 'cfop_transporte';
    Cfop_ConfiguracoesDatasetcfop_transporte.Required := True;
    Cfop_ConfiguracoesDatasetcfop_combustivel.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_combustivel.Name := 'Cfop_ConfiguracoesDatasetcfop_combustivel';
    Cfop_ConfiguracoesDatasetcfop_combustivel.FieldName := 'cfop_combustivel';
    Cfop_ConfiguracoesDatasetcfop_combustivel.Required := True;
    Cfop_ConfiguracoesDatasetcfop_transferencia.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_transferencia.Name := 'Cfop_ConfiguracoesDatasetcfop_transferencia';
    Cfop_ConfiguracoesDatasetcfop_transferencia.FieldName := 'cfop_transferencia';
    Cfop_ConfiguracoesDatasetcfop_transferencia.Required := True;
    Cfop_ConfiguracoesDatasetcfop_preco_custo.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_preco_custo.Name := 'Cfop_ConfiguracoesDatasetcfop_preco_custo';
    Cfop_ConfiguracoesDatasetcfop_preco_custo.FieldName := 'cfop_preco_custo';
    Cfop_ConfiguracoesDatasetcfop_preco_custo.Required := True;
    Cfop_ConfiguracoesDatasetcfop_perda.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_perda.Name := 'Cfop_ConfiguracoesDatasetcfop_perda';
    Cfop_ConfiguracoesDatasetcfop_perda.FieldName := 'cfop_perda';
    Cfop_ConfiguracoesDatasetcfop_perda.Required := True;
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.Name := 'Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons';
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.FieldName := 'cfop_conciliacao_cupons';
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.Required := True;
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.Name := 'Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins';
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.FieldName := 'cfop_tributa_pis_cofins';
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.Required := True;
    Cfop_ConfiguracoesDatasetcodigo_interno.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetcodigo_interno.Name := 'Cfop_ConfiguracoesDatasetcodigo_interno';
    Cfop_ConfiguracoesDatasetcodigo_interno.FieldName := 'codigo_interno';
    Cfop_ConfiguracoesDatasetcodigo_interno.Required := True;
    Cfop_ConfiguracoesDatasetexcluido.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetexcluido.Name := 'Cfop_ConfiguracoesDatasetexcluido';
    Cfop_ConfiguracoesDatasetexcluido.FieldName := 'excluido';
    Cfop_ConfiguracoesDatasetexcluido.Required := False;
    Cfop_ConfiguracoesDatasetinclusao.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetinclusao.Name := 'Cfop_ConfiguracoesDatasetinclusao';
    Cfop_ConfiguracoesDatasetinclusao.FieldName := 'inclusao';
    Cfop_ConfiguracoesDatasetinclusao.Required := False;
    Cfop_ConfiguracoesDatasetalteracao.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetalteracao.Name := 'Cfop_ConfiguracoesDatasetalteracao';
    Cfop_ConfiguracoesDatasetalteracao.FieldName := 'alteracao';
    Cfop_ConfiguracoesDatasetalteracao.Required := False;
    Cfop_ConfiguracoesDatasetexclusao.SetParentComponent(Cfop_ConfiguracoesDataset);
    Cfop_ConfiguracoesDatasetexclusao.Name := 'Cfop_ConfiguracoesDatasetexclusao';
    Cfop_ConfiguracoesDatasetexclusao.FieldName := 'exclusao';
    Cfop_ConfiguracoesDatasetexclusao.Required := False;
    XDataClientCfop_ConfiguracoesGet.SetParentComponent(Self);
    XDataClientCfop_ConfiguracoesGet.Name := 'XDataClientCfop_ConfiguracoesGet';
    XDataClientCfop_ConfiguracoesGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCfop_ConfiguracoesGet, Self, 'OnLoad', 'XDataClientCfop_ConfiguracoesGetLoad');
    XDataClientCfop_ConfiguracoesGet.Left := 64;
    XDataClientCfop_ConfiguracoesGet.Top := 8;
    XDataClientCfop_ConfiguracoesDelete.SetParentComponent(Self);
    XDataClientCfop_ConfiguracoesDelete.Name := 'XDataClientCfop_ConfiguracoesDelete';
    XDataClientCfop_ConfiguracoesDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCfop_ConfiguracoesDelete, Self, 'OnLoad', 'XDataClientCfop_ConfiguracoesDeleteLoad');
    SetEvent(XDataClientCfop_ConfiguracoesDelete, Self, 'OnError', 'XDataClientCfop_ConfiguracoesDeleteError');
    XDataClientCfop_ConfiguracoesDelete.Left := 64;
    XDataClientCfop_ConfiguracoesDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbcfop.AfterLoadDFMValues;
    edcfop.AfterLoadDFMValues;
    lbcfop_movimenta_estoque.AfterLoadDFMValues;
    edcfop_movimenta_estoque.AfterLoadDFMValues;
    lbcfop_gera_financeiro.AfterLoadDFMValues;
    edcfop_gera_financeiro.AfterLoadDFMValues;
    lbcfop_substituicao.AfterLoadDFMValues;
    edcfop_substituicao.AfterLoadDFMValues;
    lbcfop_simples_faturamento.AfterLoadDFMValues;
    edcfop_simples_faturamento.AfterLoadDFMValues;
    lbcfop_servico.AfterLoadDFMValues;
    edcfop_servico.AfterLoadDFMValues;
    lbcfop_participa_dre.AfterLoadDFMValues;
    edcfop_participa_dre.AfterLoadDFMValues;
    lbcfop_devolucao.AfterLoadDFMValues;
    edcfop_devolucao.AfterLoadDFMValues;
    lbcfop_transporte.AfterLoadDFMValues;
    edcfop_transporte.AfterLoadDFMValues;
    lbcfop_combustivel.AfterLoadDFMValues;
    edcfop_combustivel.AfterLoadDFMValues;
    lbcfop_transferencia.AfterLoadDFMValues;
    edcfop_transferencia.AfterLoadDFMValues;
    lbcfop_preco_custo.AfterLoadDFMValues;
    edcfop_preco_custo.AfterLoadDFMValues;
    lbcfop_perda.AfterLoadDFMValues;
    edcfop_perda.AfterLoadDFMValues;
    lbcfop_conciliacao_cupons.AfterLoadDFMValues;
    edcfop_conciliacao_cupons.AfterLoadDFMValues;
    lbcfop_tributa_pis_cofins.AfterLoadDFMValues;
    edcfop_tributa_pis_cofins.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Cfop_ConfiguracoesDataset.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetid.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetaliado_id.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetdata_base_id.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_movimenta_estoque.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_gera_financeiro.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_substituicao.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_simples_faturamento.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_servico.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_participa_dre.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_devolucao.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_transporte.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_combustivel.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_transferencia.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_preco_custo.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_perda.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_conciliacao_cupons.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcfop_tributa_pis_cofins.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetcodigo_interno.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetexcluido.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetinclusao.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetalteracao.AfterLoadDFMValues;
    Cfop_ConfiguracoesDatasetexclusao.AfterLoadDFMValues;
    XDataClientCfop_ConfiguracoesGet.AfterLoadDFMValues;
    XDataClientCfop_ConfiguracoesDelete.AfterLoadDFMValues;
  end;
end;

end.
